package com.daytimegaming.ourdailyfinances.presentation.home

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.daytimegaming.ourdailyfinances.domain.billing.SubscriptionManager
import com.daytimegaming.ourdailyfinances.domain.model.UserProfile
import com.daytimegaming.ourdailyfinances.domain.repository.UserRepository
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.launch

class ManageSubscriptionViewModel(
    private val userRepository: UserRepository,
    private val subscriptionManager: SubscriptionManager,
) : ViewModel() {
    val currentUserProfile: StateFlow<UserProfile?> = userRepository.currentUserProfile

    private val _isCancelling = MutableStateFlow(false)
    val isCancelling: StateFlow<Boolean> = _isCancelling.asStateFlow()

    private val _cancellationSuccess = MutableStateFlow(false)
    val cancellationSuccess: StateFlow<Boolean> = _cancellationSuccess.asStateFlow()

    init {
        viewModelScope.launch {
            subscriptionManager.loadProducts()
        }
    }

    fun setAndroidActivity(activity: Any?) {
        subscriptionManager.setAndroidActivity(activity)
    }

    fun upgradeSubscription(tier: String) {
        viewModelScope.launch {
            val productId = if (tier.lowercase() == "premium") {
                "subscription_premium_monthly"
            } else {
                "subscription_standard_monthly"
            }
            subscriptionManager.buyProduct(productId)
        }
    }

    fun confirmCancellation() {
        val tier = currentUserProfile.value?.subscription?.tier
        val productId = if (tier?.lowercase() == "premium") {
            "subscription_premium_monthly"
        } else if (tier?.lowercase() == "standard") {
            "subscription_standard_monthly"
        } else null
        subscriptionManager.openSubscriptionManagement(productId)
    }

    fun clearCancellationSuccess() {
        _cancellationSuccess.value = false
    }
}
